<template>
  <div class="ai-portrait-container">
    <!-- 主内容区域 -->
    <div class="main-content">
      <!-- 顶部按钮组 -->
      <div class="button-group">
        <button v-for="button in mainButtons" :key="button.id" class="main-button"
          :class="{ active: activeMainButton === button.id }" @click="handleMainButtonClick(button.id)">
          {{ button.label }}
        </button>
      </div>

      <!-- 内容区域 -->
      <div class="content-area">
        <!-- 图库管理内容 -->
        <MaterialGallery v-if="activeMainButton === 'image'" />
        <PortraitManagement v-else-if="activeMainButton === 'portrait'" />

    <!-- 关键词管理内容 -->
    <div v-else-if="activeMainButton === 'keywords'" class="keywords-content">
      <KeywordManagement />
    </div>

      </div>
    </div>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus'
import MaterialGallery from '@/components/MaterialGallery.vue'
import PortraitManagement from '@/components/PortraitManagement.vue'
import KeywordManagement from '@/components/KeywordManagement.vue'

export default {
  name: 'AiPortrait',
  components: {
    MaterialGallery,
    PortraitManagement,
    KeywordManagement
  },
  data() {
    return {
      activeMainButton: 'keywords',
      activeSubButton: 'search',
      // 主按钮配置
      mainButtons: [
        { id: 'keywords', label: '添加关键词' },
        { id: 'portrait', label: '添加画像' },
        { id: 'image', label: '添加图片' }
      ]
    }
  },
  methods: {
    handleMainButtonClick(buttonId) {
      this.activeMainButton = buttonId
      if (buttonId !== 'keywords') {
        this.activeSubButton = null
      } else {
        this.activeSubButton = 'search'
      }
    },

    handleSubButtonClick(subButtonId) {
      this.activeSubButton = subButtonId
    },

    handleAddAction(type) {
      // 这些功能现在由各自组件内部处理
      if (type === 'keywords' || type === 'portrait') {
        ElMessage.info(`正在添加${this.getMainButtonLabel(type)}...`)
      }
      // image 的添加功能在组件内部
    },

    getMainButtonLabel(type) {
      const button = this.mainButtons.find(b => b.id === type)
      return button ? button.label : ''
    },


    getAddButtonLabel(type) {
      return `添加${this.getMainButtonLabel(type).replace('添加', '')}`
    },

    getContentTitle() {
      if (this.activeMainButton === 'keywords' && this.activeSubButton) {
        return this.getSubButtonLabel(this.activeSubButton)
      }
      return this.getMainButtonLabel(this.activeMainButton)
    }
  }
}
</script>

<style scoped lang="scss">
.ai-portrait-container {
  padding: 24px;
  min-height: calc(100vh - 160px);
  background: transparent;
}

.main-content {
  background: hsla(0, 0%, 100%, .1);
  border-radius: 16px;
  padding: 24px;
  backdrop-filter: blur(10px);
}

.button-group {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.main-button {
  padding: 12px 24px;
  background: hsla(0, 0%, 100%, .1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: #e0e6ff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #ff7048;
    border-color: #ff7048;
    transform: translateY(-2px);
  }

  &.active {
    background: #ff7048;
    border-color: #ff7048;
  }
}

.sub-button-group {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  align-items: center;
  flex-wrap: wrap;
}

.sub-button {
  padding: 8px 16px;
  background: hsla(0, 0%, 100%, .1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  color: #e0e6ff;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #ff7048;
    border-color: #ff7048;
  }

  &.active {
    background: #ff7048;
    border-color: #ff7048;
  }

  &.keyword-sub-button {
    background: #ff7048;
    border-color: #ff7048;

    &:hover {
      background: #e55a3a;
      border-color: #e55a3a;
    }
  }

  &.orange-button {
    background: #ff7048;
    border-color: #ff7048;

    &:hover {
      background: #e55a3a;
      border-color: #e55a3a;
    }
  }
}

.instruction-button {
  padding: 8px 16px;
  background: transparent;
  border: 1px solid #ff7048;
  border-radius: 6px;
  color: #ff7048;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 112, 72, 0.1);
  }
}

.content-area {
  min-height: 400px;
}

// 其他内容样式
.other-content {
  .feature-card {
    background: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(110, 33, 254, 0.2);
    border-radius: 16px;

    :deep(.el-card__header) {
      background: rgba(110, 33, 254, 0.1);
      border-bottom: 1px solid rgba(110, 33, 254, 0.2);
      border-radius: 16px 16px 0 0;
      padding: 20px;
    }

    .card-header {
      .card-title {
        color: #6e21fe;
        font-weight: 600;
        font-size: 18px;
      }
    }

    .card-content {
      padding: 60px 20px;
      text-align: center;

      p {
        color: #a0a8b8;
        font-size: 16px;
        margin: 0 0 16px 0;
        line-height: 1.6;
      }

      .demo-data {
        color: #ff7048;
        font-weight: 600;
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .ai-portrait-container {
    padding: 16px;
  }

  .button-group {
    gap: 12px;

    .main-button {
      padding: 10px 20px;
      font-size: 13px;
    }
  }

  .sub-button-group {
    gap: 8px;

    .sub-button,
    .instruction-button {
      padding: 6px 12px;
      font-size: 12px;
    }
  }
}

@media (max-width: 480px) {
  .main-content {
    padding: 16px;
  }

  .button-group {
    justify-content: center;
  }

  .sub-button-group {
    justify-content: center;
  }
}
</style>

<style>
/* 全局样式 - 修复对话框问题 */
.merchant-dialog .el-dialog {
  background: rgba(13, 5, 26, 0.95) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 112, 72, 0.3);
  border-radius: 16px;
}

.merchant-dialog .el-dialog__header {
  margin: 0 !important;
  padding: 20px !important;
}

.merchant-dialog .el-dialog__title {
  color: #ffffff !important;
  font-weight: 600;
  font-size: 18px;
}

.merchant-dialog .el-dialog__body {
  padding: 20px !important;
  background: transparent !important;
}

.merchant-dialog .el-dialog__footer {
  border-top: 1px solid rgba(255, 112, 72, 0.2) !important;
  padding: 16px 20px !important;
  margin: 0 !important;
}

/* 表单标签颜色 */
.merchant-dialog .el-form-item__label {
  color: #e0e6ff !important;
  font-weight: 500;
}

/* 输入框文字颜色 */
.merchant-dialog .el-input__inner,
.merchant-dialog .el-textarea__inner {
  color: #ffffff !important;

}

.el-input__wrapper .el-input__inner,
.el-input__wrapper .el-textarea__inner {
  color: #ffffff !important;

}

.merchant-dialog .el-input__inner::placeholder,
.merchant-dialog .el-textarea__inner::placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
}

/* 输入框聚焦状态 */
.merchant-dialog .el-input__wrapper {
  background: rgba(255, 255, 255, 0.08) !important;
  border: 1px solid rgba(255, 112, 72, 0.3) !important;
  box-shadow: none !important;
}

.merchant-dialog .el-input__wrapper:hover {
  border-color: #ff7048 !important;
}

.merchant-dialog .el-input__wrapper.is-focus {
  border-color: #ff7048 !important;
  box-shadow: 0 0 0 1px #ff7048 !important;
}

/* 选择器样式 */
.merchant-dialog .el-select .el-input__inner {
  color: #ffffff !important;
}

.merchant-dialog .el-select .el-select__caret {
  color: #ff7048 !important;
}

/* 单选按钮样式 */
.merchant-dialog .el-radio__label {
  color: #e0e6ff !important;
}

.merchant-dialog .el-radio__input.is-checked .el-radio__inner {
  background-color: #ff7048 !important;
  border-color: #ff7048 !important;
}

/* 开关样式 */
.merchant-dialog .el-switch__core {
  background: rgba(255, 255, 255, 0.2) !important;
  border: 1px solid rgba(255, 112, 72, 0.3) !important;
}

.merchant-dialog .el-switch.is-checked .el-switch__core {
  background: #ff7048 !important;
  border-color: #ff7048 !important;
}

/* 日期选择器样式 */
.merchant-dialog .el-picker__panel {
  background: rgba(13, 5, 26, 0.95) !important;
  border: 1px solid rgba(255, 112, 72, 0.3) !important;
}

.merchant-dialog .el-date-picker .el-picker-panel__icon-btn,
.merchant-dialog .el-date-picker .el-date-table th {
  color: #e0e6ff !important;
}

.merchant-dialog .el-date-picker .el-date-table td.available:hover {
  color: #ff7048 !important;
}

.merchant-dialog .el-date-picker .el-date-table td.current:not(.disabled) span {
  background: #ff7048 !important;
}

/* 按钮样式 */
.merchant-dialog .el-button {
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.merchant-dialog .el-button--primary {
  background: #ff7048 !important;
  border-color: #ff7048 !important;
}

.merchant-dialog .el-button--primary:hover {
  background: #e55a3a !important;
  border-color: #e55a3a !important;
  transform: translateY(-1px);
}

/* 表格样式覆盖（确保生效） */
.el-table {
  --el-table-bg-color: transparent !important;
  --el-table-tr-bg-color: transparent !important;
  --el-table-header-bg-color: transparent !important;
  --el-table-row-hover-bg-color: rgba(255, 255, 255, 0.05) !important;
  --el-table-current-row-bg-color: rgba(255, 112, 72, 0.1) !important;
  --el-table-header-text-color: #e0e6ff !important;
  --el-table-text-color: #e0e6ff !important;
  --el-table-border-color: rgba(255, 112, 72, 0.3) !important;
}

.el-table th,
.el-table tr,
.el-table td {
  background: transparent !important;
  color: #e0e6ff !important;
  border-bottom: 1px solid rgba(255, 112, 72, 0.1) !important;
}

.el-table th {
  border-bottom: 1px solid rgba(255, 112, 72, 0.3) !important;
}

.el-table .el-table__inner-wrapper::before {
  background-color: rgba(255, 112, 72, 0.3) !important;
}
</style>